type FamilyFocusedCardProps = {
  imageSrc: string;
  title: string;
  description: string;
  alt?: string;
  direction: any;
};

export default function FamilyFocusedCard({
  imageSrc,
  title,
  description,
  alt = "Family Focused",
  direction,
}: FamilyFocusedCardProps) {
  return (
    <article className="flex flex-col bg-white rounded-xl border border-[#EBEBEB] p-6 w-full md:max-w-[370px]">
      {/* Image */}
      <img src={imageSrc} alt={alt} className="w-[80px] h-[80px] mx-auto" />

      {/* Title */}
      <p
        className="text-[16px] font-semibold text-[#2B2B2B] mt-4 mb-3 max-md:text-center"
        dir={direction}
      >
        {title}
      </p>

      {/* Description */}
      <p
        className="text-[14px] text-[#7D7D7D] leading-[1.4] font-inter"
        dir={direction}
      >
        {description}
      </p>
    </article>
  );
}
